import React from 'react';
import PropTypes from 'prop-types';
import ActionCard from './ActionCard';

const ActionCardSection = ({ cards }) => (
  <div className="container-fluid container-fluid--sitewidth pt-4">
    <div className="row justify-content-center">
      <div className="col-12 col-lg-10">
        <div
          className="row"
          style={{ marginTop: '6rem', zIndex: 1, position: 'relative' }}
        >
          {cards.map((card) => (
            <div className="col-12 col-md col-lg-4" key={card.id}>
              <div className="actioncard__wrapper">
                <ActionCard
                  icon={card.icon}
                  image={card.image}
                  excerpt={card.excerpt}
                  caption={card.caption}
                  actionText={card.actionText}
                  actionPath={card.actionPath}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

ActionCardSection.propTypes = {
  cards: PropTypes.array.isRequired,
};

export default ActionCardSection;
